module.exports = __webpack_public_path__ + "media/site_templates/www.pavingcontractors.com.au/images/testimonials-7f750509fb4f660ca7b023f40ece1e04.jpg";